import { render } from "./Rocket.vue?vue&type=template&id=9de5a8b6"
import script from "./Rocket.vue?vue&type=script&lang=js"
export * from "./Rocket.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__